<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>员工中心</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="isHideDetails = false">拜访</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!isHideDetails">
      <section class="searchBox">
        <span>
          <label>日期：</label>
          <a-range-picker
            style="width:200px"
            v-model="date"
            :placeholder="['开始时间', '结束时间']"
            @change="onChangeDate"
          />
        </span>
        <span>
          <label>项目：</label>
          <a-select
            style="min-width:160px"
            v-model="project_id"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option
              v-for="element in proList"
              :key="element.id"
              :value="element.id"
              >{{ element.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>字符串：</label>
          <a>
            <a-input
              placeholder="请输入运营姓名 | 员工姓名"
              v-model="query_field"
            />
          </a>
        </span>
        <span>
          <a-button style="margin-right:10px" @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.update_time.substring(0, 10) }}</td>
              <td>{{ item.user_name }}</td>
              <td>{{ item.name }}</td>
              <td>
                <span
                  v-show="item.entry_info != ''"
                  v-for="(element, k) in item.entry_info"
                  :key="k"
                  >{{ element.project_name + ";" }}</span
                >
                <span v-show="item.entry_info == ''">---</span>
              </td>
              <td>
                <span v-if="item.visit_type == 1">电话</span>
                <span v-else-if="item.visit_type == 2">面访</span>
                <span v-else>社交APP</span>
              </td>
              <td>
                <span v-if="item.purpose == 1">培训</span>
                <span v-else-if="item.purpose == 2">纠纷</span>
                <span v-else>回访</span>
              </td>
              <td>
                <p>{{ item.communicate }}</p>
              </td>
              <td class="operation">
                <a @click="detailPage(item)">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 详情 -->
    <visitDetail v-show="isHideDetails" :details="details" />
    <!-- 详情 end-->
  </div>
</template>
<script>
import axios from "axios";
import visitDetail from "@/components/management/visitDetail.vue";
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "日期",
        "运营姓名",
        "拜访员工",
        "员工在职项目",
        "拜访类型",
        "拜访目的",
        "沟通记录",
        "操作"
      ],
      isHideDetails: false,
      details: {},
      query_field: "",
      start_date: "",
      end_date: "",
      date: null,
      project_id: "",
      proList: []
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    visitDetail
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取项目
  },
  methods: {
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onChangeDate(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[1];
      //  console.log(this.searchDate);
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      // console.log(this.start_date);
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Resume_admin/queryAllVisit";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.query_field,
        token: window.localStorage.getItem("xnwfPcToken"),
        start_date: this.start_date,
        end_date: this.end_date,
        project_id: this.project_id
      };
      if (this.start_date == "" || this.start_date == undefined) {
        delete params.start_date;
      }
      if (this.end_date == "" || this.end_date == undefined) {
        delete params.end_date;
      }
      axios
        .post(url, params)
        .then(res => {
          //   console.log(res);
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    detailPage(val) {
      // this.$router.push({name:"resumeDetails"})
      this.details = val;
      this.isHideDetails = true;
    },
    onReset() {
      this.date = undefined;
      this.start_date = "";
      this.end_date = "";
      this.query_field = "";
      this.project_id = "";
      this.page = 1;
      this.getData();
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    display: block;
    > span {
      display: inline-block;
      margin-bottom: 10px;
      margin-right: 20px;
      a {
        display: inline-block;
      }
    }
  }
}
.searchStyle {
  > input {
    margin: 0 20px;
    width: 200px;
  }
}
</style>
